export default "__VITE_ASSET__yWIGVx9x__"